import { styled } from 'core-ui';

export const StyledScheduleItem = styled.div`
  font-family: Inter, sans-serif !important;
`;
